import {
  FormControlLabel as MuiFormControlLabel,
  FormGroup,
  Tooltip,
} from '@mui/material';
import * as S from '../containers/PropertyPanel/PropertyPanel.styles';
import { styled } from '@mui/material/styles';
import Switch from './Switch';

interface SwitchWithLabelInterface {
  value: boolean;
  setValue(val: boolean): void;
  label: string;
  size?: number;
  disabled?: boolean;
  tooltip?: string;
}

const FormControlLabel = styled(MuiFormControlLabel)`
  margin: 0;
  margin-bottom: 8px;
  margin-left: 0;
`;

export const SwitchWithLabel = ({
  value,
  setValue,
  label,
  size,
  disabled,
  tooltip,
}: SwitchWithLabelInterface) => {
  return (
    <S.FormWrapper size={size}>
      <FormGroup>
        <Tooltip title={tooltip}>
          <FormControlLabel
            label={label}
            control={
              <Switch
                checked={value}
                size='small'
                color='primary'
                onChange={() => setValue(!value)}
                disabled={disabled}
              />
            }
          />
        </Tooltip>
      </FormGroup>
    </S.FormWrapper>
  );
};
